/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';

import KP from '../../Images/svg/KP-Logo.svg';
import NDS from '../../Images/svg/NDS-Logo.svg';
import MLsolution from '../../Images/svg/ML-Solution.svg';



function Footer(props) {
  const region = props?.region || 'usa';

  return (
    <>
      {region === 'usa' ? (
        <footer className="py-4 white-bg">
          <div className="container mt-24 mb-24">
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="row mt-96 mb-40">
                  <div className="col-12 mb-24">
                    <img src={KP} alt="KP monograma" class="d-inline-block align-text-top img-40" />
                    <img src={MLsolution} alt="KP monograma" class="d-inline-block align-text-top img-40 ml-32" />
                  </div>
                  <div className="col-12 d-flex align-items-center">
                    <p className='h3 -b'>Get in touch with us</p>
                  </div>
                  <div className="col-12 d-flex align-items-center">
                    <a href="https://www.linkedin.com/company/key-prediction/">
                      <button className="btn -icon -xl">
                        <i class="fa-brands fa-linkedin"></i>
                      </button>
                    </a>
                    <p className="h4 mb-0">
                      <a href="miguel@keyprediction.com">
                        miguel@keyprediction.com
                      </a>
                    </p>
                  </div>
                  <div className="col-12 mt-24">
                    <p className="h3 -b mb-0">Call us</p>
                    <p className="caption">Call our team Mon-Fri from 8am to 5pm. (GMT-6)</p>
                    <a className='mt-0'>
                      <p className='body-1 mt-8'>+1 954 940 1272</p>
                    </a>
                  </div>
                  <div className="col-12 mt-24">
                    <p className="h3 -b mb-0">Chat with us in person at our HQ!</p>
                    <p className="caption mb-8">(By appointment only)</p>
                    <a href="https://maps.app.goo.gl/FrxpyUuBm9M9hXmd7">
                      <p className='body-1 mt-8'>3131 Camino Del Rio N, 92108 California</p>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 mb-40 mb-md-0">
                <p className='h3 -b'>Products & Solutions</p>
                <ul className="list-unstyled">
                  <li>
                    <a href="https://www.ndscognitivelabs.com/conversational-ai/">Conversational Al</a>
                  </li>
                  <li>
                    <a href="https://keyprediction.com/products">Trend Spotting</a>
                  </li>
                  <li>
                    <a href="https://keyprediction.com/products">Data Analytics and Business Intelligence Dashboards</a>
                  </li>
                  <li>
                    <a href="https://keyprediction.com/products">Recommendation Systems</a>
                  </li>
                  <li>
                    <a href="https://keyprediction.com/products">Content Generation</a>
                  </li>
                  <li>
                    <a href="https://keyprediction.com/products">Computer Vision</a>
                  </li>
                </ul>
                <div className="row">
                  <div className="col-12">
                  </div>
                  <div className="col-12 col-md-6">
                    <ul className="list-unstyled">
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center mt-40">
              <p className='label'>&copy; 2026 KeyPrediction. All rights reserved.</p>
            </div>
          </div>
        </footer>
      )
        :
        (
          <footer className="py-4 white-bg">
            <div className="container mt-24 mb-24">
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="row mt-96 mb-40">
                    <div className="col-12 mb-24">
                      <img src={KP} alt="KP monograma" class="d-inline-block align-text-top img-40" />
                      <img src={MLsolution} alt="KP monograma" class="d-inline-block align-text-top img-40 ml-32" />
                    </div>
                    <div className="col-12 d-flex align-items-center">
                      <p className='h3 -b'>¡Contáctanos!</p>
                    </div>
                    <div className="col-12 d-flex align-items-center">
                      <a href="https://www.linkedin.com/company/key-prediction/">
                        <button className="btn -icon -xl">
                          <i class="fa-brands fa-linkedin"></i>
                        </button>
                      </a>
                      <p className="h4 mb-0">
                        <a href="marketing@keyprediction.com">
                          marketing@keyprediction.com
                        </a>
                      </p>
                    </div>
                    <div className="col-12 mt-24">
                      <p className="h3 -b mb-0">Llámanos</p>
                      <p className="caption">(Comunícate con nuestro equipo de lunes a viernes de 8am to 5pm. (GMT-6))</p>
                      <a className='mt-0'>
                        <p className='body-1 mt-8'>+1 954 940 1272</p>
                      </a>
                    </div>
                    <div className="col-12 mt-24">
                      <p className="h3 -b mb-0">Visítanos en nuestras oficinas</p>
                      <p className="caption mb-8">(Con cita previa)</p>
                      <a href="https://maps.app.goo.gl/7dzkyxDg9iHXVUgg8">
                        <p className='body-1 mt-8'>Paseo de la Castellana 93, 28046 Madrid</p>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 mb-40 mb-md-0">
                  <p className='h3 -b'>Productos y soluciones</p>
                  <ul className="list-unstyled">
                    <li>
                      <a href="https://www.ndscognitivelabs.com/conversational-ai/">IA conversacional</a>
                    </li>
                    <li>
                      <a href="https://keyprediction.com/products">Detección de tendencias</a>
                    </li>
                    <li>
                      <a href="https://keyprediction.com/products">Análisis de Datos e Inteligencia Empresarial</a>
                    </li>
                    <li>
                      <a href="https://keyprediction.com/products">Sistemas de recomendaciones</a>
                    </li>
                    <li>
                      <a href="https://keyprediction.com/products">Generación de contenido</a>
                    </li>
                    <li>
                      <a href="https://keyprediction.com/products">Visión computacional (Computer Vision)</a>
                    </li>
                  </ul>
                  <div className="row">
                    <div className="col-12">
                    </div>
                    <div className="col-12 col-md-6">
                      <ul className="list-unstyled">
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center mt-40">
                <p className='label'>&copy; 2026 KeyPrediction. Todos los derechos reservados.</p>
              </div>
            </div>
          </footer>
        )}
    </>
  );
}

export default Footer;